module.exports = __webpack_public_path__ + "arrow-success1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pictures/arrow-success1.png
// module id = 518
// module chunks = 0